var url = process.env.API_URL + process.env.API_VERSION;
import axios from 'axios';

const state = {
  list_counselor_on_hompage: []
}

const mutations = {
  SET_LIST_COUNSELORS(state, list_counselors){
    state.list_counselor_on_hompage = list_counselors
  }
}

const actions = {
  fetch_data({commit}){
    axios.get(url + "/users/get_list_counselors?per_page=8",
      {
      })
      .then((response) =>{
        commit('SET_LIST_COUNSELORS', response.data.extra.counselors)
      })
  }
}

const getters = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/vuex_homepage.js